export default "__VITE_ASSET__0dbf72e2__"